import { Component } from '@angular/core';
import { MMobileHelperService } from '@core/services/core/mmobile-helper.service';
import { UrlHelper } from '@core/services/helpers/url-helper.service';

@Component({
  selector: 'app-business-login-footer',
  templateUrl: './business-login-footer.component.html',
  styleUrls: ['./business-login-footer.component.scss'],
})
export class BusinessLoginFooterComponent {

  constructor(public url: UrlHelper, private mmobileHelper: MMobileHelperService) { }

  showCookieSettings() {
    // @ts-ignore
    OneTrust.ToggleInfoDisplay();
  }

  openPrivacyPolicyBusiness() {
    this.url.open(
      this.mmobileHelper.getCustomConfigData('URLS', 'PRIVACY_POLICY_BUSINESS')
    );
  }

}
